<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="6">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Android (正式)</span>
            <el-button style="float: right; padding: 3px 0" type="text">
              上传
            </el-button>
          </div>
          <div class="desc">最新：</div>
          <div class="item">
            <div class="version">1.0.5</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="desc">历史：</div>
          <div class="item">
            <div class="version">1.0.4</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="item">
            <div class="version">1.0.3</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="item">
            <div class="version">1.0.2</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="item">
            <div class="version">1.0.1</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="item">
            <div class="version">1.0.0</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>Android (测试)</span>
            <el-button style="float: right; padding: 3px 0" type="text">
              上传
            </el-button>
          </div>
          <div class="desc">最新：</div>
          <div class="item">
            <div class="version">1.0.5</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="desc">历史：</div>
          <div class="item">
            <div class="version">1.0.4</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="item">
            <div class="version">1.0.3</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="item">
            <div class="version">1.0.2</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="item">
            <div class="version">1.0.1</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="item">
            <div class="version">1.0.0</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>PC (正式)</span>
            <el-button style="float: right; padding: 3px 0" type="text">
              上传
            </el-button>
          </div>
          <div class="desc">最新：</div>
          <div class="item">
            <div class="version">1.0.5</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="desc">历史：</div>
          <div class="item">
            <div class="version">1.0.4</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="item">
            <div class="version">1.0.3</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="item">
            <div class="version">1.0.2</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="item">
            <div class="version">1.0.1</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="item">
            <div class="version">1.0.0</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>PC (测试)</span>
            <el-button style="float: right; padding: 3px 0" type="text">
              上传
            </el-button>
          </div>
          <div class="desc">最新：</div>
          <div class="item">
            <div class="version">1.0.5</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="desc">历史：</div>
          <div class="item">
            <div class="version">1.0.4</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="item">
            <div class="version">1.0.3</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="item">
            <div class="version">1.0.2</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="item">
            <div class="version">1.0.1</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
          <div class="item">
            <div class="version">1.0.0</div>
            <div class="btn-group">
              <el-button type="text">下载</el-button>
              <el-button type="text" disabled>删除</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileList: [
        {
          name: 'food.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        },
        {
          name: 'food2.jpeg',
          url:
            'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
        }
      ]
    }
  },
  methods: {
    submitUpload() {
      this.$refs.upload.submit()
    },
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    handlePreview(file) {
      console.log(file)
    }
  }
}
</script>

<style scoped lang="scss">
.desc {
  height: 40px;
  line-height: 40px;
  font-weight: bold;
  font-size: 16px;
}
.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}
.item:last-child {
  margin-bottom: 0;
}
</style>
